import { Api } from '@axiom/ui';
import type { Confirmation, ConfirmationEdit } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class ConfirmationsApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiPortalUrl,
      cookieDomain: EnvUtil.cookieDomain,
    });
  }

  async updateConfirmation(
    id: Confirmation['id'],
    confirmation: Partial<ConfirmationEdit>
  ) {
    return super.write<{ data: Confirmation }>({
      endpoint: `/confirmations/${id}`,
      body: confirmation,
      method: 'PATCH',
    });
  }
}

export const ConfirmationsApi = new ConfirmationsApiClass();
